module.exports = __webpack_public_path__ + "assets/img/VIPBenefits.dff3cd0b.png";